<template>
    <div class="facturas w-full h-full bg-color-01" :class="[!isCollapsed ? 'wide-table-width':'tight-table-width']">
       <!-- <div class="w-full bg-primary-800 p-6">Cargando</div> -->
        <div v-if="getLoading && !mostrarTodas && !ErrorCarga" class="w-full flex items-center px-5 h-13 bg-orange-700  left-5">Cargando Facturas de los últimos 12 meses. Por favor, espere.</div>
        <div v-if="getLoading && mostrarTodas && !ErrorCarga" class="w-full flex items-center px-5 h-13 bg-orange-700 left-5">Cargando histórico completo de Facturas. Por favor, espere.</div>
        <div v-if="!getLoading && !mostrarTodas && !ErrorCarga" class="w-full flex items-center px-5 h-13 bg-green-700 left-5">Se están mostrando sus facturas de los últimos 12 meses. Si desea obtener todo el histórico completo de facturas, pulse el botón 'Mostrar histórico completo' situado en la esquina inferior derecha</div>
        <div v-if="!getLoading && mostrarTodas && !ErrorCarga" class="w-full flex items-center px-5 h-13 bg-green-700 left-5">Se están mostrando todas las facturas del histórico</div>
        <div v-if="!getLoading && ErrorCarga" class="w-full flex items-center px-5 h-13 bg-red-700 left-5">Se produjo un error al obtener las facturas para su visualización. Por favor, inténtelo nuevamente refrescando la página o volviendo a acceder al portal</div>

        <kendo-grid ref="KendoG" :data-source="getFacturas(this.state)"
          :pageable="pageable"
          :filterable="true"
          :filterChange="onFilterChange"
          :reorderable="true"
          :resizable="true"
          :sortable="true"
          :column-menu="true"
          :change="onChange">
          <kendo-grid-column class="max-w-10" :width="40" :selectable="true"/>
          <kendo-grid-column :width="120" :field="'Id'"
                  :title="'ID'">
          </kendo-grid-column>
          <kendo-grid-column :width="250" :field="'CIF'"
                  :title="'CIF'">
          </kendo-grid-column>
          <kendo-grid-column :width="250" :field="'Proveedor'"
                  :title="'Razón Social'">
          </kendo-grid-column>
          <kendo-grid-column  :width="120" :field="'NumeroFactura'"
                  :title="'Número Factura'">
          </kendo-grid-column>
          <kendo-grid-column :width="150" :field="'Importe'"
                  :title="'Importe'"
                  :format="'{0:n}'">
          </kendo-grid-column>
           <kendo-grid-column  :width="120" :field="'FechaSubida'"
                  :title="'Fecha Subida'">
          </kendo-grid-column>
           <kendo-grid-column  :width="120" :field="'FechaFactura'"
                  :title="'Fecha Factura'">
          </kendo-grid-column>
        </kendo-grid>
         <!-- <div class="buttons-bar absolute bottom-0 right-0 w-full flex items-center justify-end h-12 pr-4">
          <Button type="primary" size="small" icon="el-icon-upload2"><span class="hidden sm:inline-block">Exportar</span></Button>
        </div> -->
        <div class="buttons-bar absolute bottom-0 right-0  flex items-center justify-end h-12 pr-4">
          <Button @click="mostrarTodas = true; getSolpheoFacturas('', true)" type="primary" size="small"><span class="hidden sm:inline-block">Mostrar histórico completo</span></Button>
          <Button @click="exportExcel" type="primary" size="small" icon="el-icon-upload2"><span class="hidden sm:inline-block">Exportar</span></Button>
        </div>
      </div>
</template>
<script>
import moment from 'moment'
import format from 'date-fns/format'
import { Grid, GridColumn } from '@progress/kendo-grid-vue-wrapper'
import { Button } from 'element-ui'
import { mapState, mapGetters } from 'vuex'
import getFacturas from '../utils/solpheoListFacturas'
import { saveExcel } from '@progress/kendo-vue-excel-export'
var lang = require('element-ui/lib/locale/lang/es').default
var locale = require('element-ui/lib/locale')
locale.use(lang)

export default {
  name: 'list',

  created () {
    const { state } = this.$route.params
  },
  props: {
    state: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters(['getFacturas', 'getLoading'])
  },
  components: {
    Button,
    'kendo-grid': Grid,
    'kendo-grid-column': GridColumn
  },
  methods: {
    async getSolpheoFacturas (Estado, MostrarFacturas) {
      this.ErrorCarga = false
      this.$store.commit('setLoading', true)
      this.$store.commit('setFacturasDataSource', [])
      try {
        const { Estado, Mensaje, Facturas } = await getFacturas(Estado, MostrarFacturas)
        if (Estado === 'KO' || !Estado) {
          if (Mensaje === 'Token caducado') {
            alert('Sesión Caducada, por favor, inicie sesión nuevamente')
            localStorage.removeItem('token')
            this.$router.push({ name: 'login' })
          } else {
            this.ErrorCarga = true
          }
        }
        this.$store.commit('setFacturasDataSource', Facturas)
        this.$store.commit('setLoading', false)
      } catch (error) {
        alert('Se produjo un error al obtener las facturas para su visualización. Por favor, inténtelo nuevamente refrescando la página o volviendo a acceder al portal')
        this.ErrorCarga = true
        this.$store.commit('setLoading', false)
      }
    },
    exportExcel () {
      saveExcel({
        data: this.$refs.KendoG.dataSource,
        filterable: true,
        fileName: 'Facturas_' + new Date().getDate(),
        columns: [
          { field: 'Id', title: 'ID' },
          { field: 'CIF', title: 'CIF' },
          { field: 'Proveedor', title: 'Razón Social' },
          { field: 'NumeroFactura', title: 'Número Factura' },
          { field: 'Importe', title: 'Importe' },
          { field: 'FechaSubida', title: 'Fecha subida' },
          { field: 'FechaFactura', title: 'Fecha factura' }
        ]
      })
    },
    clearDate () {
      this.dateOne = ''
      this.dateTwo = ''
    },
    onChange (ev) {
      const selected = ev.sender.select()[0]
      const id = ev.sender.dataItem(selected).Id
      console.log('id: ' + id)
      const stateFacturas = this.state
      this.$router.push({ name: 'documentDetail', params: { id, stateFacturas } })
    },
    onFilterChange (filter) {
      console.log('filter' + filter)
    },
    dataStateChange () {
      console.log('click en onChangePage')
    },
    formatDates (dateOne, dateTwo) {
      let formattedDates = 'Seleccione fechas'
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat)
      }
      if (dateTwo) {
        formattedDates += ' - ' + format(dateTwo, this.dateFormat)
      }
      return formattedDates
    }
  },
  data: function () {
    return {
      isCollapsed: false,
      darkMode: true,
      dates: '',
      mostrarTodas: false,
      ErrorCarga: false,
      dateFormat: 'D MMM YYYY',
      dateOne: '',
      dateTwo: '',
      pageable: {
        refresh: true,
        buttonpageSizeCount: 5,
        pageSize: 50,
        pageSizes: [50, 100, 500, 'All']
      }
    }
  },
  async mounted () {
    this.getSolpheoFacturas('', false)
  }
}

</script>
